const ViewBoolean = (props) => {
  return props.value ? "Oui" : "Non";
};

export default ViewBoolean;
